export const NO_RESULTS_TITLE = "No data available";
export const NO_RESULTS_SUBTITLE = "There seems no data available to show";

export const NO_SEARCH_RESULTS_TITLE = "No results found";
export const NO_SEARCH_RESULTS_SUBTITLE = "Please try a different search";

export const NO_SEARCH_RESULTS_WITH_FILTERS_TITLE = "No results found";
export const NO_SEARCH_RESULTS_WITH_FILTERS_SUBTITLE =
  "Please try different keywords or change the filters";
export const NO_RESULTS_FOR_FILTERS_TITLE = "No results found";
